import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';

// Controls
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule, IConfig } from 'ngx-mask';

// --Material
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Routing
import { routing } from './app.routing';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

// Components
import { AppComponent } from './app.component';
import { EnterNewPasswordComponent } from './components/enterNewPassword/enterNewPassword.component';
import { EnterOldPasswordComponent } from './components/enterOldPassword/enterOldPassword.component';
import { EnterPhoneComponent } from './components/enterPhone/enterPhone.component';
import { EnterSMSCodeComponent } from './components/enterSMSCode/enterSMSCode.component';

// Pages
import { ChangePasswordComponent } from './pages/changePassword/changePassword.component';
import { LoginComponent } from './pages/login/login.component';
import { RestorePasswordComponent } from './pages/restorePassword/restorePassword.component';
import { RegistrationByPhoneComponent } from './pages/registrationByPhone/registrationByPhone.component';
import { RegistrationContentHeader } from './pages/registrationByPhone/modules/registrationContentHeader/registrationContentHeader.component';
import { UserAgreementComponent } from './pages/userAgreement/userAgreement.component';
import { CuratorRegistrationComponent } from './pages/curator-registration/curator-registration.component';

// Sections
import { HeaderComponent } from './sections/header/header.component';
import { FooterComponent } from './sections/footer/footer.component';

// Module
import { PhoneInputModule } from './module/phone-input/phone-input.module';
import {NgxDadataModule} from '@kolkov/ngx-dadata';
import {MatDialogModule} from '@angular/material/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { RatsorgRegistrationComponent } from './pages/ratsorg-registration/ratsorg-registration.component';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { RationalizatorRegistrationComponent } from './pages/rationalizator-registration/rationalizator-registration.component';
import {TextMaskModule} from 'angular2-text-mask';
import { CaptchaComponent } from './components/captcha/captcha.component';
import {RestorePasswordDialog} from './module/restore-password-dialog/restore-password-dialog.component';
import { PasswordInputComponent } from './module/password-input/password-input.component';

@NgModule({
    declarations: [
        AppComponent,
        EnterNewPasswordComponent,
        EnterOldPasswordComponent,
        EnterPhoneComponent,
        EnterSMSCodeComponent,

        ChangePasswordComponent,
        LoginComponent,
        RegistrationByPhoneComponent,
        RegistrationContentHeader,
        RestorePasswordComponent,
        UserAgreementComponent,
        CuratorRegistrationComponent,

        HeaderComponent,
        FooterComponent,
        RatsorgRegistrationComponent,
        RationalizatorRegistrationComponent,
        CaptchaComponent,
        RestorePasswordDialog,
        PasswordInputComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        NgxMaskModule.forRoot(),
        BrowserModule.withServerTransition({appId: 'ng-cli-universal'}),
        HttpClientModule,
        NgxDadataModule,
        MatTreeModule,
        MatCheckboxModule,
        MatIconModule,
        MatTableModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressBarModule,
        TextMaskModule,


        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient]
            }
        }),

        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,

        routing,

        BrowserAnimationsModule,

        PhoneInputModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
    ],
    providers: [
        DatePipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './themes/default/assets/locale/', '.json');
}

